import { noop } from 'lodash';

import environmentallyFriendly from './environment';
import perf from './perf';

export const nonProductionTimer = {
  start(name: string) {
    // eslint-disable-next-line no-console
    console.time(`${name}`);
    perf.mark(`${name}:start`);
  },

  stop(name: string) {
    perf.mark(`${name}:end`);
    perf.measure(name, `${name}:start`, `${name}:end`);
    // eslint-disable-next-line no-console
    console.timeEnd(`${name}`);
  },
};

export const productionTimer = {
  start: noop,
  stop: noop,
};

export default environmentallyFriendly({
  production: productionTimer,
  nonProduction: nonProductionTimer,
});
